// extracted by mini-css-extract-plugin
export default {"page":"SearchPlaceView_page__-dH2r","container":"SearchPlaceView_container__KjhVs","searchbars":"SearchPlaceView_searchbars__plziM"};